export const DaysConverter = (time) => {
  const parsedDate = new Date(time);
  const referenceDate = new Date();
  // absolute difference in milliseconds
  const diffMs = Math.abs(parsedDate.getTime() - referenceDate.getTime());

  const totalMinutes = diffMs / (1000 * 60);
  if (totalMinutes < 60) {
    // round to nearest minute, but at least 1 minute
    const minutes = Math.max(1, Math.round(totalMinutes));
    return `${minutes} Minute${minutes === 1 ? "" : "s"}`;
  }

  const totalHours = totalMinutes / 60;
  if (totalHours < 24) {
    // round to nearest hour, but at least 1 hour
    const hours = Math.max(1, Math.round(totalHours));
    return `${hours} Hour${hours === 1 ? "" : "s"}`;
  }

  const totalDays = totalHours / 24;
  const days = Math.max(1, Math.round(totalDays));
  return `${days} Day${days === 1 ? "" : "s"}`;
};
